import { Vendor } from "../CRUDs/entities/Vendor";
import errors from "../errors";
var Mustache = require('mustache');
import masks from '../masks'
var getMessagesProgress = false;
var getUsersProgress = false;
import { Validator } from "../snippets/Validator";

const validation_fields = [
    'email',
    'phone',
    'first_name',
    'last_name',
    'address',
    'city',
    'state',
    'zip_code',
]
const vendor_validation_fields = [
    'email',
    'phone',
    'vendor_name',
    'address',
    'zip_code'
];

export default {

    numValue:'+1 ',

    init() {

        if ($('#chat-messages').length) {
            this.scrollMessageBottom();
            this.sendMessage();
            this.userFullSearch();
            this.doneMessages();
        }
        if (window.location.pathname.match('/email-')) {
            this.showOnlyEmailSubmitButtons();
        }
        if (window.location.pathname.match('/phone-')) {
            this.showOnlyPhoneSubmitButtons();
        }
        if (! window.location.pathname.match(/\/cockpit.{0,1}$/)) {
            $('#follow-ups').show();
        }
        if($('input[name=customer_id]').val()!='') //Временный фикс для Subject
            $(`.chat[data-id="${$('input[name=customer_id]').val()}"]`).trigger('click')

        //this.getCurrentUser(this);
        this.numpadInit()
        this.loadMessagesOnScroll();
        this.getUserInfoModal();
        this.getUserInfoEditModal();
        this.updateUser();
        this.getForwardModal();
        this.forwardEmail();

        this.getTemplatesModal();
        this.getCreateTemplateModal();
        this.createTemplate();
        this.getEditTemplateModal();
        this.saveTemplate();
        this.insertTemplate();
        this.deleteTemplate();

        this.getFollowUpsModalAdd();
        this.getFollowUpsModalEdit();
        this.createFollowUp();

        this.showConnectPad();
        this.checkUser();

        this.getContactOptionsModal();
        this.blockContact();
        this.markAsLead();

        this.saveContactToCustomer();

        this.messagesSettingsModal();
        this.breakEmailChain();

        this.showForwardButtons();

        this.enterDialPadNumber();
        this.showCarbonCopiesModal();


        this.getEmailAdditionalInfoModal();

        // Защита от дурака, если пытается выйти из Cockpit
        //TODO: Больше не имеет смысла т.к. на сайте подключены пуши
        /*if(!/^popup-cockpit/.test(window.name))
            window.onbeforeunload = function (e) {

                let cockpit_reload_flag = localStorage.getItem('cockpit_reload_flag');
                let message = 'Warning! You are currently on call and trying to close the page. It will result in a dropped call.';

                console.log('cockpit_reload_flag: ' + cockpit_reload_flag);
                if (cockpit_reload_flag === 'true') {
                    localStorage.setItem('cockpit_reload_flag', 'false');
                    delete e['returnValue'];
                } else {

                    console.log(message, e, window.event);

                    e = e || window.event;

                    // For IE and Firefox
                    if (e) {
                        e.returnValue = message;
                    }

                    // For Safari
                    return message;
                }
            };*/

        $('.cockpit-call-phone').removeClass('d-none');
        $('.cockpit-forwarding-phone').addClass('d-none');

        // setTimeout(function () {
        //     $('#call-toggle').click();
        // }, 1000 * 5);

        if (settings['call_forwarding_phone']) {
            $('.cockpit-call-phone').addClass('d-none');
            $('.cockpit-forwarding-phone').removeClass('d-none');
        }
        if (cockpit_default_subject) {
            $('.cockpit-subject-input-value').attr('placeholder', cockpit_default_subject);
            $('.cockpit-subject-input-value').val('');
            $('.cockpit-subject-input-hidden').val(cockpit_default_subject);
        }

        $('body').on('click', '.container-chat #subscriptions', function (e) { //ЗДЕСЬ КЛИК ПО SUBSCRIPTIONS
            window.open('/subscription', '_blank').focus();
        });

        // change status in Order Receipt
        $('body').on('click', '.change-status', function (e) {

            e.preventDefault();
            let data = $(this).data();
            let order_id = data.order_id;

            $.ajax({
                type: 'GET',
                url: '/order_status',
                data: {
                    "order_id" : order_id,
                    "type": "action-list",
                },
                success: function (response) {
                    $('#change_status_modal_info').html(response);
                    $('#order_status_modal').css('z-index', 1060);
                    $('#order_status_modal').modal('show');
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });

        $('body').on('keyup', '.cockpit-subject-input-value', function(e) {
            e.preventDefault();
            $('#cockpit-subject-checkbox-input').prop('checked', true);
            $('.cockpit-subject-input-hidden').val($('.cockpit-subject-input-value').val());
        });

        return this;
    },

    scrollMessageBottom() {
        let scroll = 0;
        $('.message').each(function(i, el) {
            if ($(el).find('.new-messages').length > 0) {
                return false;
            }
            scroll += $(el).height();
        });
        var chat_messages = document.querySelector('.messages-cockpit-content');
        if (chat_messages != null) {
            chat_messages.scrollTop = scroll;
        }
    },
    sendMessage() {
        let $this = this;
        $('body').on('click', '#chat-messages .send', function (e) {
            e.preventDefault();
            let id = $('.sending')[0].id;
            $('#status_message').html('<div class="alert alert-info">Sending message...</div>');
            let form = $(this).closest('form')[0];
            let data = new FormData(form);
            data.append('carbon_copies', $('#cc_list').val());
            $.ajax({
                type: 'POST',
                enctype: 'multipart/form-data',
                url: '/cockpit/' + id,
                data: data,
                processData: false,
                contentType: false,
                success: function () {
                    $('#chat-messages textarea').val('');
                    let last_message = $('.last_message').last().text();
                    $this.sendDone(last_message);
                    $('#status_message').html('<div class="alert alert-success">Sending message is successful</div>');
                    $('#attachments').html('');
                    $('#attach_input').val('');
                    $this.clearCCForm();
                    // setTimeout(function () {
                    //     $this.scrollMessageBottom();
                    // }, 500);
                },
                error: function (response) {
                    let errors = '<div class="alert alert-danger"><ul>';
                    $.each(response.responseJSON.errors, function (index, value) {
                        errors += '<li>' + value + '</li>';
                    });
                    errors += '</ul></div>';
                    $('#status_message').html(errors);
                },
                complete: function () {
                    setTimeout(function () {
                        // $this.scrollMessageBottom();
                        $('#status_message').html('');
                    }, 1000 * 5);
                    $('#message').countSms('#sms-counter');
                }
            });
        })
    },
    getMessages(curr_id = null, click = null, older_message_time = null, from = '', typeUser=null, isScroll=false) {
        // console.log('call getMessages( ' + curr_id + ', ' + click + ', ' + older_message_time + ')' + (new Error()).stack);

        let uriPathNameParsed = window.location.pathname.split('/');

        if (older_message_time != null) {
            if ($('.is_empty_mesasges').length > 0) return;
        }
        if(isScroll)
            $('#loading-center').show();
        if (getMessagesProgress === false) {
            let $this = this;
            let last_message = null;
            if (! curr_id && ! older_message_time) {
                last_message = $('.last_message').last().text();
            }
            let customer_id = $("input[name=customer_id]").val();
            if ($(click).find('.chat-title.a').length > 0) {
                customer_id = click.id;
            }

            $.ajax({
                type: 'POST',
                url: '/cockpit/org-get-messages/' + window.organisation_id,
                data: ({
                    phone: $("#send-form input[name=phone]").val() ? $("#send-form input[name=phone]").val() : $(click).data('user_phone'),
                    email: $("#send-form input[name=email]").val() ? $("#send-form input[name=email]").val() : $(click).data('user_email'),
                    customer_id: customer_id,
                    last_message: last_message,
                    older_message_time: older_message_time,
                    type: typeUser
                }),
                success: function (response) {
                    if (click) {
                        $this.replaceCountNewMessages(click);
                    }else{
                        $this.replaceCountNewMessages();
                    }
                    if (curr_id) {
                        $('#chat-messages #messages').html(response);
                    }else if(older_message_time){
                        let old_height = document.getElementById('messages').scrollHeight;
                        $('#messages').prepend(response);
                        let new_height = document.getElementById('messages').scrollHeight;
                        let scroll = new_height - old_height;
                        $('#messages').scrollTop(scroll);
                        return;
                    }else{
                        $('#chat-messages #messages').append(response);
                    }

                    if (response != '') {
                        setTimeout(function () {
                            $this.scrollMessageBottom();
                        }, 500);
                    }
                },
                complete: function () {
                    setTimeout(function () {
                        getMessagesProgress = false;
                        $('#loading-center').hide();
                    }, 500);
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }
    },
    doneMessages() {
        let $this = this;
        $('body').on('click', '.send_done', function(e) {
            e.preventDefault();
            let message = $(this).closest('.message')[0];
            let last = $($(message).find('.last_message')[0]).text();

            $this.sendDone(last, message);
        });
    },
    sendDone(last, message = null) {
        let $this = this;
        $.ajax({
            type: 'POST',
            url: '/cockpit/org-done-messages/' + window.organisation_id,
            data: ({
                last_message: last,
                customer_id: $($('.user_data')[0]).data('id'),
                phone: $("input[name=phone]").val() ? $("input[name=phone]").val() : $($('.user_data')[0]).data('user_phone'),
                email: $("input[name=email]").val() ? $("input[name=email]").val() : $($('.user_data')[0]).data('user_email'),
                entity_type: $('#send-form input[name=type]').val()
            }),
            success: function (response) {
                $this.getMessages();
                $this.getUsers();
                $('.new-messages').remove();
                $(message).append($('#new_message').html());
                let date_this_message = new Date(last);
                $('.ready').each(function(i, el) {
                    let this_message = $($(el).closest('.message')[0]);
                    let this_date = $(this_message.find('.last_message')[0]);
                    let date_el = new Date(this_date.text());
                    if (date_el.getTime() <= date_this_message.getTime()) {
                        $(el).text('Done');
                        $($(this_message).find('.send_done')).remove();
                        $($(this_message).find('.reader')[0]).text($('#reader').text());
                    }
                });
            },
        }).fail(function (jqXHR, exception) {
            if (jqXHR.status == 403) {
                localStorage.setItem('cockpit_reload_flag', true);
                window.location.reload();
            }
        });
    },
    loadMessagesOnScroll() {
        let $this = this;
        console.log('INIT SCROLL')
        $('.messages-cockpit-content').on('scroll', function () {
            let older_message_time = $('.last_message').first().text();
            let in_progress = false;
            let table = $('.messages-cockpit-content');
            if (table.scrollTop() == 0 && !in_progress) {
                in_progress = true;
                $this.getMessages(null, null, older_message_time, '', null, true);
                in_progress = false;
            }
        });
    },
    getUsers(curr_id = null) {
        if (getUsersProgress === false) {
            getUsersProgress = true;
            $('#loading-left').show();

            $.ajax({
                type: 'POST',
                url: '/cockpit/org-get-users/' + window.organisation_id,
                data: ({
                    current_phone: $("input[name=phone]").val(),
                    current_email: $("input[name=email]").val(),
                    user_name: $('input[name="first_name"]').val()+' '+$('input[name="last_name"]').val(),
                    letters: $('#user_full_search').val(),
                    chat_select: $('input[name="chat_select"]:checked').val(),
                }),
                success: function (response) {
                    $('#loading-left').hide();
                    let oldText = $('#chat-messages #users').text().replaceAll(" ","").replaceAll("\r","").replaceAll("\n","");
                    let newText = $(response).text().replaceAll(" ","").replaceAll("\r","").replaceAll("\n","");

                    if (oldText != newText) {
                        $('#chat-messages #users').html(response);
                    }

                    if (curr_id) {
                        $('.chat').each(function (i, el) {
                            $(el).find('.chat-content').removeClass('open')
                            $(el).removeClass('active')
                            if (el.id == curr_id) {
                                $(el).addClass('active')
                                $(el).find('.chat-content').addClass('open');
                            }
                        });
                    }

                    document.title = window.blinkTitle;

                    $.ajax({
                        type: 'POST',
                        url: '/cockpit/org-get-count-new-messages',
                        success: function (response) {
                            $('#new_customers').text(response.users);
                            $('#new_not_customers').text(response.not_customers);
                            //$('#new_incidents').text(response.incidents);
                            $('#new_vendors').text(response.vendors);
                            //$('#new_customers_with_incidents').text(response.messages_users_with_incidents);
                            $('.chat-count-new').each(function(i,el) {
                                if ($(el).text() == 0) {
                                    $(el).hide();
                                }else{
                                    $(el).show();
                                }
                            });

                            let messageTitleCount = response.users + response.not_customers;

                            document.title = window.blinkTitle + ' (' + messageTitleCount + ')';
                        }
                    }).fail(function (jqXHR, exception) {
                        if (jqXHR.status == 403) {
                            localStorage.setItem('cockpit_reload_flag', true);
                            window.location.reload();
                        }
                    });
                },
                complete: function() {
                    setTimeout(function () {
                        getUsersProgress = false;
                    }, 500);
                }
            }).fail(function (jqXHR, exception) {
                $('#loading-left').hide();
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }
},
    getCurrentUser(from_this) {
        let $this = this;
        if ($(from_this).data('id')) {
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-get-current-user/' + window.organisation_id,
                data: ({
                    id: $(from_this).data('id'),
                    type: $(from_this).data('type')
                }),
                success: function (response) {
                    console.log(response);
                    $this.replaceCurrentUser(from_this, response)
                    $this.clearCCForm();
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }
    },
    replaceCurrentUser(from_this, response) {
        let $this = this;
        $("input[name=phone]").val(response.phone);
        $("input[name=email]").val(response.email);
        let hide = false;
        let files = [];
        if (response.type == 'vendor') {
            hide = true;
            files = response.files;
        }

        $this.replaceIncidents(response.incidents, hide);
        $this.replaceOrders(response.orders);
        $this.replaceJobs(response.jobs);
        $this.replaceSubscriptions(response.subscriptions);
        $this.replaceUserInfo(response);
        $this.replaceFollowUps(hide);
        $this.replaceVendorFiles(files,!hide, response.id);
        $('.cockpit-subject-input-value').attr('placeholder', response.email_subject);
        $('.cockpit-subject-input-value').val('');
        $('.cockpit-subject-input-hidden').val(response.email_subject);
        $('#cockpit-subject-checkbox-input').prop('checked', false);

        $this.getUsers();
        $this.getMessages($(from_this).data('id'), from_this,null,null, $('#send-form input[name="type"]').val());
        if ($(from_this).data('user_email') && $(from_this).data('user_phone')) {
            $this.showAllSubmitButtons();
        }else if ($(from_this).data('user_email')) {
            $this.showOnlyEmailSubmitButtons();
        }else{
            $this.showOnlyPhoneSubmitButtons();
        }

        if ($('input[name="chat_select"]:checked').val() == 'Customers')
            $('#contact-options-modal .add-follow-up').removeClass('d-none')
        else
            $('#contact-options-modal .add-follow-up').addClass('d-none')

        /*let vh100 = window.innerHeight;
        if (window.innerWidth < 1024) {
            if ($('#send-form input[name=email]').val() == '') {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 375px + 90px)');
            } else {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 375px)');
            }
        } else {
            if ($('#send-form input[name=email]').val() == '') {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 315px + 85px)');
            } else {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 315px)');
            }
        }*/

        setTimeout(function() {
            if (window.innerWidth < 1024) {

                $('#cockpit-leads-link').hide();

                // if ($('.chat-content.open').length > 0) {
                    $('.left-sidebar').hide();

                    $('.center-sidebar').show();

                    // $('#send-form').css('position', 'fixed');
                    // $('#send-form').css('width', '100%');
                    // $('#send-form').css('padding', '1rem');
                    // $('#send-form').css('left', '0');

                    $('.cockpit-buttons').removeClass('col-11').addClass('col-12');
                    //$('.cockpit-textarea-col').removeClass('col-11').addClass('col-12');
                    $('.cockpit-button-send-col').hide();
                    $('.send-button').show();

                    $('.cockpit-textarea-links').css('position', 'absolute');
                    $('.cockpit-textarea-links').css('top', '-50px');
                    $('.cockpit-textarea-links').css('z-index', '99');
                    $('.cockpit-textarea-links').css('right', '0');

                    $('.right-sidebar').hide();

                    $('.cockpit-call-phone').hide();
                    $('.cockpit-call-off').css('display','none');
                    $('.cockpit-wrapper .additional-btns').css('display','none');
                    $('.show_logs_modal').hide();

                    let name = $('input[name="chat_select"]:checked').val() == 'Customers'
                        ? response.first_name+' '+response.last_name: $(from_this).data('user_phone');
                    if (!name) {
                        name = $(from_this).data('user_email');
                        if (!name)
                            name = $(from_this).data('id')
                    }

                    if($('input[name="chat_select"]:checked').val() == 'Customers')
                        $('.mobile-links .mobile-link-additional').removeClass('d-none')
                    else
                        $('.mobile-links .mobile-link-additional').addClass('d-none')


                    console.log($(from_this).data('user_phone'), $(from_this).data('user_email'), $(from_this).data('id'));

                    $('.mobile-back-to-list-button .info').html(name);
                    $('.mobile-back-to-list-button .add-info-phone').text($('input[name="chat_select"]:checked').val() == 'Customers' ? $(from_this).data('user_phone') : '');
                    $('.mobile-back-to-list-button .add-info-email').text($(from_this).data('user_phone') ? $(from_this).data('user_email') : '');



                // }
/*

                else {
                    $('.left-sidebar').show();

                    $('.center-sidebar').hide();

                    $('#send-form').css('position', '');
                    $('#send-form').css('width', '');
                    $('#send-form').css('padding', '');
                    $('#send-form').css('left', '');

                    $('.cockpit-buttons').removeClass('col-12').addClass('col-11');
                    $('.cockpit-textarea-col').removeClass('col-12').addClass('col-11');
                    $('.cockpit-button-send-col').show();
                    $('.send-button').hide();

                    $('.cockpit-textarea-links').css('position', '');
                    $('.cockpit-textarea-links').css('top', '');
                    $('.cockpit-textarea-links').css('z-index', '');
                    $('.cockpit-textarea-links').css('right', '');

                    $('.right-sidebar').hide();

                    $('.cockpit-call-phone').hide();
                    $('.show_logs_modal').hide();
                    $('.container.cockpit-wrapper').css('padding', '');
                }

*/
            } else {
                $('#cockpit-leads-link').show();
                $('.left-sidebar').show();

                $('.center-sidebar').show();

                $('#send-form').css('position', '');
                $('#send-form').css('width', '');
                $('#send-form').css('padding', '');
                $('#send-form').css('left', '');

                $('.cockpit-buttons').removeClass('col-12').addClass('col-11');
                //$('.cockpit-textarea-col').removeClass('col-12').addClass('col-11');
                $('.cockpit-button-send-col').show();
                $('.send-button').hide();

                $('.cockpit-textarea-links').css('position', '');
                $('.cockpit-textarea-links').css('top', '');
                $('.cockpit-textarea-links').css('z-index', '');
                $('.cockpit-textarea-links').css('right', '');

                $('.right-sidebar').show();

                $('.cockpit-call-phone').show();
                $('.cockpit-call-off').css('display','flex');
                $('.cockpit-wrapper .additional-btns').css('display','');
                $('.show_logs_modal').show();
            }
        }, 1000);

    },
    showAllSubmitButtons() {
        $('#sendButton').prop('disabled', false);

        $('#org_send_sms').removeClass(['d-none', 'btn-primary', 'sending']);
        $('#org_send_sms').addClass('btn-light');

        $('#org_send_email').removeClass(['d-none', 'btn-light']);
        $('#org_send_email').addClass(['btn-primary', 'sending']);

        $('#call').removeClass('d-none');

        if (document.querySelector('#nonVerificationMessage')) {
            $('#nonVerificationMessage').removeClass('d-none').addClass('d-lg-flex');
        }

        $('#sms-counter').html('<b>Email</b>');
        // $('#sms-counter').html('<b>SMS</b> <span class="remaining">160</span> / <span class="messages">0</span>');

        $('#org_send_email .svg_1').css('display', 'inline-block');
        $('#org_send_email .svg_2').css('display', 'none');

        $('#org_send_sms .svg_1').css('display', 'none');
        $('#org_send_sms .svg_2').css('display', 'inline-block');

        $('.messages_settings').removeClass('d-none');

        $('#org_send_email').trigger('click');
    },

    showOnlyPhoneSubmitButtons() {
        if ($("#twilioPhoneVerification").val() === "1") {
            $('#sendButton').prop('disabled', false);
        } else {
            $('#sendButton').prop('disabled', true);
        }

        $('#call').removeClass('d-none');

        $('#org_send_sms').removeClass(['d-none', 'btn-light']);
        $('#org_send_sms').addClass(['btn-primary', 'sending']);

        $('#org_send_email').addClass('d-none');
        $('#org_send_email').removeClass(['btn-primary', 'sending']);

        if (document.querySelector('#nonVerificationMessage')) {
            $('#nonVerificationMessage').removeClass('d-none').addClass('d-lg-flex');
        }

        $('#sms-counter').html('<b>Email</b>');
        // $('#sms-counter').html('<b>SMS</b> <span class="remaining">160</span> / <span class="messages">0</span>');

        $('#org_send_sms .svg_1').css('display', 'inline-block');
        $('#org_send_sms .svg_2').css('display', 'none');
        $('#org_send_email .svg_1').css('display', 'none');
        $('#org_send_email .svg_2').css('display', 'inline-block');

        $('.messages_settings').addClass('d-none');

        $('#org_send_sms').attr('disabled', false);
        $('#org_send_sms').trigger('click');
        if ($("#twilioPhoneVerification").val() !== "1") {
            $('#org_send_sms').attr('disabled', true);

        }

    },
    showOnlyEmailSubmitButtons() {
        $('#org_send_email').addClass(['btn-primary', 'sending']);
        $('#org_send_email').removeClass(['d-none', 'btn-light']);
        $('#org_send_sms').addClass('d-none');
        $('#org_send_sms').removeClass(['btn-primary', 'sending']);
        $('#call').addClass('d-none');

        if (document.querySelector('#nonVerificationMessage')) {
            $('#nonVerificationMessage').addClass('d-none').removeClass('d-lg-flex');
        }

        $('#sms-counter').html('<b>Email</b>');
        $('#org_send_sms .svg_1').css('display', 'none');
        $('#org_send_sms .svg_2').css('display', 'inline-block');
        $('#org_send_email .svg_1').css('display', 'inline-block');
        $('#org_send_email .svg_2').css('display', 'none');

        $('.messages_settings').removeClass('d-none');
        $('#org_send_email').trigger('click');
    },
    replaceCountNewMessages(user) {
        // $.ajax({
        //     type: 'POST',
        //     url: '/cockpit/get-count-new-messages',
        //     success: function (response) {
        //         $('#new_customers').text(response.users);
        //         $('#new_not_customers').text(response.not_customers);
        //         $('#new_incidents').text(response.incidents);
        //         $('#new_customers_with_incidents').text(response.messages_users_with_incidents);
        //         $('.chat-count-new').each(function(i,el) {
        //             if ($(el).text() == 0) {
        //                 $(el).hide();
        //             }else{
        //                 $(el).show();
        //             }
        //         })
        //     }
        // });
    },
    replaceUserInfo(user) {
        let tmpl = $('#user_info_tmpl').html();
        let view = user;
        let html = Mustache.render(tmpl, view);
        $('.sidebar_user_info').html(html);
    },
    replaceOrders(orders) {
        if (orders && orders.length > 0) {
            $('#orders').removeClass('d-none');
            $('#orders #orders-cont').html('');
            for(let order of orders){
                let template = $('#right-order-tmpl').clone(true)
                template.attr('id','')
                template.removeClass('d-none')
                //template.attr('href', `/service-list?entity_class=orders&id=${order.id}`)
                template.attr('onclick', `showEntityModalUniversal((${order.id}),event, '/get-order-modal/')`);
                template.find('.order-type').text(order.products[0].title)
                template.find('.order-date').text(order.created_at_date)
                template.find('.order-status').text(order.pay_status)
                template.find('.order-total').text('$'+Number(order.total).toFixed(2))
                $('#orders #orders-cont').append(template)
            }
        }else{
            $('#orders').addClass('d-none');
        }
    },
    replaceJobs(jobs) {
        if(jobs && jobs.length > 0){
            $('#jobs').removeClass('d-none');
            $('#jobs #jobs-cont').html('');
            for(let job of jobs){
                let template = $('#right-job-tmpl').clone(true)
                template.attr('id','')
                template.removeClass('d-none')
                // template.attr('href', `/jobs-flow?entity_class=${job.entity}&${job.entity=='jobs' ? `job_request_id=${job.job_request_id}` : `id=${job.id}`}`)
                template.attr('href', '#')
                template.find('.job-type-name').text(job.entity=='jobs' ? 'Job: ' : 'Job Request: ')
                template.find('.job-type').text(job.service_name)
                template.find('.job-date').text(job.created_at_date)
                template.find('.job-status').text(job.status)
                template.find('.job-total').text('$'+Number(job.total).toFixed(2))
                template.attr('data-customer_id', job.customer_id);
                template.attr('data-entity_id', job.entity=='jobs' ? job.job_request_id : job.id);
                template.attr('data-entity', job.entity=='jobs' ? 'job' : 'request');
                $('#jobs #jobs-cont').append(template)
            }
        }else{
            $('#jobs').addClass('d-none');
        }
    },
    replaceVendorFiles(vendor_files, hide, vendor_id){
        if (hide) {
            $('#vendors_attachments').addClass('d-none');
            return;
        }else{
            $('#vendors_attachments').removeClass('d-none');
        }
        let files = '<div class="d-flex justify-content-between align-items-start pt-3 px-3">'+
                    '<div class="flex-1 cockpit-title">Files & Pictures</div>'+
                    `<div class="mt-1 text-right flex-1 text-nowrap text-primary mb-2 cursor-pointer add-vendor-attachemnt upload-files" data-id="${vendor_id}" data-file_type="doc" data-entity="vendor">+ Pics &amp; Docs</div>`+
                    '</div>';
        if (vendor_files && vendor_files.length > 0) {
            files += '<div class="files-container d-flex flex-wrap px-3">';
            vendor_files.forEach(element => {
                let path = '/images/document-image.png';
                if (element.type == 'img') {
                    path = `/files/${element.path}`;
                }
                files += '<div class="file d-flex flex-column justify-content-between">'+
                            '<div class="mb-2">'+
                                `<img class="vendor-image" src="${path}">`+
                            '</div>'+
                            '<div class="d-flex justify-content-between mb-1">'+
                                `<div class="file-name"><a class="text-primary preview-file-btn" href="#" data-src="${path}">${element.name}</a></div>`+
                                `<div class="file-menu cursor-pointer d-flex align-items-center" data-id="${vendor_id}" data-file_id="${element.id}" data-d_link="${element.d_link}">`+
                                    '<div class="dots"></div>'+
                                '</div>'+
                            '</div>'+
                            '<div class="file-description">'+
                                `<div class="size">${element.size}</div>`+
                                `<div class="upload-time">${element.time}</div>`+
                            '</div>'+
                        '</div>'
            });

        }
        files += '</div></div>'
        $('#vendors_attachments').html(files);
        if (vendor_id) {
            const vendor = new Vendor(vendor_id);
            vendor.scopeOpenDropZoneListener();
            vendor.setAttachmentCallbackDelete(()=>{
                let elem = $('.chat-content.open').parent();
                elem.click();
                $('.file-menu-modal').hide();
            });
            vendor.setAttachmentCallbackPreview();
        }
    },
    replaceSubscriptions(subscriptions){
        console.log('SUBS: ', subscriptions)
        if(subscriptions && subscriptions.length > 0){
            $('#subscriptions').removeClass('d-none');
            $('#subscriptions #subscriptions-cont').html('');
            for(let sub of subscriptions){
                let template = $('#right-sub-tmpl').clone(true)
                template.attr('id','')
                template.removeClass('d-none')
                template.find('.subs-title').text(sub?.service?.title)
                template.find('.subs-date').text(sub.created_at_date)
                $('#subscriptions #subscriptions-cont').append(template)
            }
        }else{
            $('#subscriptions').addClass('d-none');
        }
    },
    replaceFollowUps(hide = false) {
        if (hide) {
            $('#follow-ups').hide();
        }else{
            $('#follow-ups').show();
            let customer_id = $('#send-form input[name="customer_id"]').val();
            let contact = '';
            let data = {};
            if (customer_id === "") {
                let email = $('#send-form input[name="email"]').val();
                if (email !== "") {
                    contact = email;
                }else{
                    contact = $('#send-form input[name="phone"]').val();
                }
                data = {contact: contact};
            }else{
                data = {user_id: customer_id};
            }

            $.ajax({
                type: 'GET',
                url: '/cockpit/get-follow-ups',
                data: data,
                success: function (response) {
                    $('#follow-ups .row').removeClass('d-none');
                    $('#follow-ups-outer').html(response);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }
    },
    replaceIncidents(incidents, hide=false) {
        if (incidents) {
            $('#incidents').removeClass('d-none');
            $('#incidents #incidents-cont').html('');
            $('#incidents #add-incident').removeClass('d-none').addClass('d-flex');
            $('#incidents #other-incident').addClass('d-none');
            for(let incident of incidents){
                let template = $('#right-incident-tmpl').clone(true)
                console.log(incident)
                template.attr('id','')
                template.removeClass('d-none')
                template.find('.incident-title').text(incident.title)
                template.find('.incident-date').text(incident.created_at)
                template.find('.incident-details').text(incident.details)
                template.find('.incident-creator').text(`Created by ${incident.creator}`)
                template.attr('data-incident_id', incident.id)
                $('#incidents #incidents-cont').append(template)
            }
        } else if (window.location.pathname.match('/phone-') || window.location.pathname.match('/email-')) {
            $('#incidents').removeClass('d-none');
            $('#incidents #incidents-cont').html('');
            $('#incidents #add-incident').removeClass('d-flex').addClass('d-none');
            $('#incidents #other-incident').removeClass('d-none');
        }else if(hide){
            $('#incidents').addClass('d-none');
        }
    },
    userFullSearch() {
        let $this = this;
        $('body').on('input','#user_full_search', function(e) {
            if ($('#user_full_search').val().length > 3 || $('#user_full_search').val().length == 0) {
                setTimeout($this.getUsers, 2000);
            }
        });
    },
    forwardingList() {
        $.ajax({
            type: 'POST',
            url: '/cockpit/forwarding-list',
            success: function (response) {
                $('.forwarding').html(response);
            }
        }).fail(function (jqXHR, exception) {
            if (jqXHR.status == 403) {
                localStorage.setItem('cockpit_reload_flag', true);
                window.location.reload();
            }
        });
    },
    getUserInfoModal() {
        $('body').on('click', '#contact-options-modal .chat-title, #incidents .chat-title, #contact-options-modal .vendor-info', function(e) {
            e.preventDefault();
            let id = $('.user_data').data('id');
            let id2 = $(this).parent().find('.queue_user_id').text();
            if (id || id2) {
                let user_id = id;
                if (!user_id) user_id = id2;
                let url = '/cockpit/user_info/' + user_id;
                if ($('#send-form input[name="type"]').val() == 'vendor') {
                    url = '/cockpit/vendor_info/' + user_id;
                }
                $.ajax({
                    type: 'GET',
                    url: url,
                    success: function (response) {
                        if($('#user_info_modal').length)
                            $('#user_info_modal').replaceWith(response);
                        else
                            $('.container-fluid').append(response);
                        $('.open_chat').addClass('d-none');
                        if (id) {
                            $('#contact-options-modal').modal('hide');
                        }
                        $('#user_info_modal').modal('show');
                    },
                }).fail(function (jqXHR, exception) {
                    if (jqXHR.status == 403) {
                        localStorage.setItem('cockpit_reload_flag', true);
                        window.location.reload();
                    }
                });
            }else{
                if ($(this).hasClass('vendor-info')) {
                    $('#contact-options-modal').modal('hide');
                    $('#create-vendor-form')[0].reset();
                    $('#create-vendor-form input[name="phone"]').val($('.user_data').data('user_phone'));
                    $('#create-vendor-form input[name="email"]').val($('.user_data').data('user_email'));
                    $('#vendor-create-modal').modal('show');
                } else {
                    $('#contact-options-modal').modal('hide');
                    $('#create-contact-form')[0].reset();
                    $('#create-contact-form input[name="phone"]').val($('.user_data').data('user_phone'));
                    $('#create-contact-form input[name="email"]').val($('.user_data').data('user_email'));
                    $('#contact-create-modal').modal('show');
                }
            }
        });
    },
    saveContactToCustomer() {
        let $this = this;

        for(let field of validation_fields){
            $(`#create-contact-form input[name=${field}]`).on('input',()=>{
                if(this.validationForm('create-contact-form',validation_fields))
                    $(`#create-contact-form button[type="submit"]`).attr('disabled',false);
                else
                    $(`#create-contact-form button[type="submit"]`).attr('disabled',true);
            })
        }
        for(let field of vendor_validation_fields){
            $(`#create-vendor-form input[name=${field}]`).on('input',()=>{
                if(this.validationForm('create-vendor-form',vendor_validation_fields))
                    $(`#create-vendor-form button[type="submit"]`).attr('disabled',false);
                else
                    $(`#create-vendor-form button[type="submit"]`).attr('disabled',true);
            })
        }


        $('body').on('click', '#contact-create-modal button', function(e) {
            e.preventDefault();
            let form = $('#create-contact-form')[0];
            if(!$this.validationForm('create-contact-form',validation_fields,true))
                return;
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-save-contact-to-customer',
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#contact-create-modal #customer').data('id', response.customer_id);
                    $('#contact-create-modal #customer').data('user_email', $('#contact-create-modal input[name="email"]'));
                    $('#contact-create-modal #customer').data('user_phone', $('#contact-create-modal input[name="phone"]'));
                    $('input[name=customer_id]').val(response.customer_id);
                    history.pushState(null, null, '/cockpit/' + response.public_id);
                    $this.getCurrentUser($('#contact-create-modal #customer')[0]);
                    $('#contact-create-modal').modal('hide');
                    $('#select-customers').trigger('click');
                },
                error: function (response) {
                    if(response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors)
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });

        $('body').on('click', '#vendor-create-modal button', function(e) {
            e.preventDefault();
            let form = $('#create-vendor-form')[0];
            if(!$this.validationForm('create-vendor-form',vendor_validation_fields,true))
                return;
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-save-contact-to-vendor',
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#vendor-create-modal #customer').data('id', response.customer_id);
                    $('#vendor-create-modal #customer').data('user_email', $('#vendor-create-modal input[name="email"]'));
                    $('#vendor-create-modal #customer').data('user_phone', $('#vendor-create-modal input[name="phone"]'));
                    $('input[name=customer_id]').val(response.customer_id);
                    $('input[name=type]').val('vendor');
                    history.pushState(null, null, '/cockpit/' + response.customer_id + '/vendor');
                    $this.getCurrentUser($('#vendor-create-modal #customer')[0]);
                    $('#vendor-create-modal').modal('hide');
                    $('#select-vendors').trigger('click');
                },
                error: function (response) {
                    if(response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors)
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    validationForm(formId,validationFields,isSelectErrorFields=false){
        const formData = new FormData($(`#${formId}`)[0]);
        const validator = new Validator({
            'email': ['required'],
            'phone': ['required', {regexp: /[0-9]{3}-[0-9]{3}-[0-9]{4}/}],
            'first_name': ['required'],
            'last_name': ['required'],
            'vendor_name': ['required'],
        });

        let validate_flag = true;

        validationFields.forEach(element => {
            if (validator.validate(element, formData.get(element))) {
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').removeClass('border-danger').css('border','');
            }else{
                validate_flag = false;
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').addClass('border-danger').css('border','2px solid');
            }
        });

        return validate_flag;
    },
    getUserInfoEditModal() {
        const $this = this
        $('body').on('click', '#user_info_modal .user_info_edit', function(e) {
            e.preventDefault();
            let id = $('.user_data').data('id');
            $.ajax({
                type: 'GET',
                url: '/cockpit/user_info_edit/' + id,
                success: function (response) {
                    if($('#user_info_edit_modal').length)
                        $('#user_info_edit_modal').replaceWith(response);
                    else
                        $('.container-fluid').append(response);
                    const validateCb = () => {
                        if ($this.validationForm('user-info-form', validation_fields))
                            $(`#user-info-form button[type="submit"]`).attr('disabled', false)
                        else
                            $(`#user-info-form button[type="submit"]`).attr('disabled', true)
                    }
                    validateCb()
                    for(let field of validation_fields){
                        $(`#user-info-form input[name=${field}]`).on('input', validateCb)
                    }
                    $('#user_info_edit_modal').modal('show');
                    masks.init();
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
        $('body').on('click', '#user_info_modal .vendor_info_edit', function(e) {
            e.preventDefault();
            let id = $('.user_data').data('id');
            $.ajax({
                type: 'GET',
                url: '/cockpit/vendor_info_edit/' + id,
                success: function (response) {
                    if($('#vendor_info_edit_modal').length)
                        $('#vendor_info_edit_modal').replaceWith(response);
                    else
                        $('.container-fluid').append(response);
                    let validation_fields = [
                        'email',
                        'phone',
                        'vendor_name',
                        'address',
                        'zip_code'
                    ];
                    const validateCb = () => {
                        if ($this.validationForm('vendor-info-form', validation_fields))
                            $(`#vendor-info-form button[type="submit"]`).attr('disabled', false)
                        else
                            $(`#vendor-info-form button[type="submit"]`).attr('disabled', true)
                    }
                    validateCb()
                    for(let field of validation_fields){
                        $(`#vendor-info-form input[name=${field}]`).on('input', validateCb)
                    }
                    $('#vendor_info_edit_modal').modal('show');
                    masks.init();
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    updateUser() {
        const $this = this
        $('body').on('click', '.customer-info-submit-form', function(event) {
            event.preventDefault();
            $('.alert').addClass('d-none')
                        .removeClass('alert-danger')
                        .removeClass('alert-success')
                        .text('');
            if(!$this.validationForm('user-info-form',validation_fields,true))
                return;
            let form = $(this).closest('form')[0];
            let data = new FormData(form);
            $.ajax({
                type: 'POST',
                url: '/cockpit/user_info_update',
                data: data,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.success) {
                        $('.component-data-save .text-success')
                            .removeClass('d-none')
                            .text(response.message);

                        if (response.updatedInfo) {
                            for (let key in response.updatedInfo) {
                                $(`[data-e-field="${key}"]`).text(response.updatedInfo[key]);
                            }
                        }
                        setTimeout(() => {
                            $('.component-data-save .text-success')
                            .addClass('d-none')
                            .text('');
                            $('#user_info_edit_modal').modal('hide');
                        }, 1000)
                    }
                },
                error: (response)=>{
                    if(response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors)
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });

        $('body').on('click', '.vendor-info-submit-form', function(event) {
            event.preventDefault();
            let validation_fields = [
                'email',
                'phone',
                'vendor_name',
                'address',
                'zip_code'
            ];
            if(!$this.validationForm('vendor-info-form',validation_fields,true))
                return;
            let form = $(this).closest('form')[0];
            let data = new FormData(form);
            $.ajax({
                type: 'POST',
                url: '/cockpit/vendor_info_update',
                data: data,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.success) {
                        $('.component-data-save .text-success')
                            .removeClass('d-none')
                            .text(response.message);

                        if (response.updatedInfo) {
                            for (let key in response.updatedInfo) {
                                $(`[data-e-field="${key}"]`).text(response.updatedInfo[key]);
                            }
                        }
                        setTimeout(() => {
                            $('.component-data-save .text-success')
                            .addClass('d-none')
                            .text('');
                            $('#vendor_info_edit_modal').modal('hide');
                        }, 1000)
                    }
                },
                error: (response)=>{
                    if(response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors)
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    getContactOptionsModal() {
        $('body').on('click', '.open-contact-options', function(e) {

            e.preventDefault();
            e.stopPropagation();
            $('.form-validation-errors').removeClass(['alert', 'alert-danger', 'alert-success']).html('');

            let id    = $('.user_data').data('id');
            let phone = $('.user_data').data('user_phone');
            let email = $('.user_data').data('user_email');

            if (id) {
                $('#contact-options-modal #user_id').val(id);
                $('#contact-options-modal #user_id').show();
                $('#contact-options-modal .mark_as_lead').hide();
                $('#contact-options-modal .vendor-info').hide();
            }else{
                $('#contact-options-modal #user_id').hide();
                $('#contact-options-modal .mark_as_lead').show();
                $('#contact-options-modal .vendor-info').show();
            }
            $.ajax({
                type: 'GET',
                url: '/org-block-contact/check',
                data: ({
                    id: id,
                    phone: phone,
                    email: email
                }),
                success: function (response) {
                    $('#block-contact').data('blocked', response.blocked);
                    $('#block-contact').addClass(response.blocked === 1 ? 'btn-primary' : 'btn-outline-primary');
                    $('#block-contact').removeClass(response.blocked === 1 ? 'btn-outline-primary' : 'btn-primary');
                    $('#block-contact').text(response.blocked === 1 ? 'Unblock Contact' : 'Block Contact');
                    $('#contact-options-modal').modal('show');

                    if(response.lead == 1) {
                        $('.mark_as_lead').data('lead', 1);
                        $('.mark_as_lead').removeClass('btn-outline-primary').addClass('btn-primary');
                    } else {
                        $('.mark_as_lead').data('lead', 0);
                        $('.mark_as_lead').removeClass('btn-primary').addClass('btn-outline-primary');
                    }
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    getForwardModal() {
        $('body').on('click', '.forward-email', function(e) {
            e.preventDefault();
            let id = $(this).data('forward');
            $('#forward-' + id).toggleClass(['d-none', 'd-flex']);
            $('.response-messages').removeClass(['alert-success', 'alert-danger']).addClass(['d-none']);
            $('#forward_id').val($(this).data('forward'));
            $('#forvard_modal').modal('show');
        });
    },
    forwardEmail() {
        $('body').on('click', '#forward_email_button', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/cockpit/org_forward_system_email',
                data: ({
                    id: $('#forward_id').val(),
                    email: $('#forward_input').val(),
                }),
                success: function (response) {
                    $('.response-messages').html(response.message).removeClass(['d-none']).addClass(['alert-success'])
                    setTimeout(function() {
                        $('.response-messages').html('').addClass(['d-none'])
                        $('#forvard_modal').modal('hide');
                    }, 3000);
                },
                error: function (response) {
                    $('.response-messages').html(response.error).removeClass(['d-none']).addClass(['alert-danger'])
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    getTemplatesModal() {
        let $this = this;
        $('body').on('click', '#chat-messages #template_message', function(e) {
            if ( ! $('#chat-messages #templates-outer #template-messages-modal').html() ) {
                $this.getTemplates();
            }else{
                $('#template-messages-modal').modal('show');
            }
        });
    },
    getTemplates() {
        $.ajax({
            type: 'GET',
            url: '/cockpit/org-show-templates',
            success: function (response) {
                $('#chat-messages #templates-outer').html(response);
                $('#template-messages-modal').modal('show');
            },
        }).fail(function (jqXHR, exception) {
            if (jqXHR.status == 403) {
                localStorage.setItem('cockpit_reload_flag', true);
                window.location.reload();
            }
        });
    },
    getCreateTemplateModal() {
        $('body').on('click', '#chat-messages #show-create-template', function(e) {
            $('#template-name').val('');
            $('#template-text').val('');
            errors.hideAlerts();
            $('#create-template-message-modal').modal('show');
        });
    },
    createTemplate() {
        let $this = this;
        $('body').on('click', '#chat-messages #create-template', function(e) {
            e.preventDefault();

            let form = $('#chat-messages #new-template')[0];
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-create-template',
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#chat-messages #create-template-message-modal').modal('hide');
                    $this.getTemplates();
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    saveTemplate() {
        let $this = this;
        $('body').on('click', '#chat-messages #save-template', function(e) {
            e.preventDefault();
            let form = $('#chat-messages #edit-template')[0];
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-save-template',
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#chat-messages #edit-template-message-modal').modal('hide');
                    $this.getTemplates();
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    getEditTemplateModal() {
        $('body').on('click', '#chat-messages .edit-template', function(e) {
            $('#template-messages-modal').modal('hide');
            $.ajax({
                type: 'GET',
                url: '/cockpit/org-edit-template',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#chat-messages #edit-template-outer').html(response);
                    $('#chat-messages #edit-template-message-modal').modal('show');
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    insertTemplate() {
        $('body').on('click', '#chat-messages .insert-template', function(e) {
            e.preventDefault();
            $('#chat-messages #message').val($(this).text().trim());
            $('#template-messages-modal').modal('hide');
        });
    },
    deleteTemplate() {
        let $this = this;
        $('body').on('click', '#chat-messages #delete-template', function(e) {
            e.preventDefault();
            let id = $(this).data('id');
            if (confirm('Delete this template?')) {
                $.ajax({
                    type: 'POST',
                    url: '/cockpit/org-delete-template',
                    data: ({
                        id: id,
                    }),
                    success: function (response) {
                        $('#chat-messages #edit-template-message-modal').modal('hide');
                        $this.getTemplates();
                    },
                    error: function (response) {
                        let err = response.responseJSON.errors;
                        errors.showAlerts(err);
                    },
                }).fail(function (jqXHR, exception) {
                    if (jqXHR.status == 403) {
                        localStorage.setItem('cockpit_reload_flag', true);
                        window.location.reload();
                    }
                });
            }
        });
    },
    getFollowUpsModalAdd() {
        $('body').on('click', '.add-follow-up', function(e) {
            e.preventDefault();
            let customer_id = $('#send-form input[name="customer_id"]').val();
            $('#follow_up_modal #user_id').val(customer_id);
            if (customer_id === "") {
                let email = $('#send-form input[name="email"]').val();
                if (email !== "") {
                    $('#follow_up_modal #contact').val(email);
                }else{
                    $('#follow_up_modal #contact').val($('#send-form input[name="phone"]').val());
                }
            }
            let form = $('#new-follow-up')[0];
            form.reset();
            $('#follow_up_modal #fid').val('');
            $('#follow_up_modal #title').text('Add');
            $('#follow_up_modal #create-follow-up').text('Add');
            $('#follow-up-date').datetimepicker();
            $('#contact-options-modal').modal('hide');
            $('#follow_up_modal .modal-header .inner-title').text('Add Follow-Up')
            $('#follow_up_modal').modal('show');
        });
    },
    getFollowUpsModalEdit() {
        $('body').on('click', '.edit-follow-up', function(e) {
            e.preventDefault();
            let id = $(this).data('follow_up_id');
            $.ajax({
                type: 'GET',
                url: '/cockpit/get-follow-up',
                data: ({
                    id: id,
                }),
                success: function (response) {
                    $('#follow_up_modal #title').text('Edit');
                    $('#follow_up_modal #create-follow-up').text('Save');
                    $('#follow_up_modal #fid').val(id);
                    $('#follow_up_modal #user_id').val(response.message.user_id);
                    $('#follow_up_modal #contact').val(response.message.contact);
                    $('#follow_up_modal #follow-up-date').val(response.message.time);
                    $('#follow_up_modal #follow-up-comment').val(response.message.comment);
                    $('#follow-up-date').datetimepicker();
                    $('#follow_up_modal .modal-header .inner-title').text('Edit Follow-Up')
                    $('#follow_up_modal').modal('show');
                },
                error: function (response) {

                },
                complete: function (response) {

                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    createFollowUp() {
        let $this = this;
        $('body').on('click', '#follow_up_modal #create-follow-up', function(e) {
            e.preventDefault();
            let user_id = $('#follow_up_modal #user_id');
            if (user_id.val().length <= 0)  user_id.prop('disabled', true);
            let contact = $('#follow_up_modal #contact');
            if (contact.val().length <= 0)  contact.prop('disabled', true);
            let fid = $('#follow_up_modal #fid');
            let url = '';
            if (fid.val()) {
                url = '/cockpit/edit-follow-up';
            }else{
                url = '/cockpit/create-follow-up';
            }

            let form = $('#new-follow-up')[0];
            $.ajax({
                type: 'POST',
                url: url,
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#follow_up_modal').modal('hide');
                    form.reset();
                    $this.replaceFollowUps();
                },
                error: function (response) {

                },
                complete: function (response) {
                    user_id.prop('disabled', false)
                    contact.prop('disabled', false)
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    showConnectPad() {
        $('body').on('click', '.show-connect-pad', function(e) {
            e.preventDefault();
            $('#connect-pad-modal #connect-email').val('');
            $('#connect-pad-modal #connect-phone').val('');
            $("#connect-phone").mask("000-000-0000");
            $('#connect-pad-modal').modal('show');
        });
    },
    checkUser() {
        let $this = this;
        $('body').on('click', '#connect-chat', function(e) {

            e.preventDefault();

            let id;
            if ($('#connect-pad-modal #connect-email').val().length) {
                id = 'email-' + $('#connect-pad-modal #connect-email').val();
            } else {
                id = 'phone-' + $('#connect-pad-modal #connect-phone').val();
                if ($('#connect-pad-modal #connect-phone').val().length <= 3) {
                    window.location.replace('/cockpit');
                    return;
                }
            }
            id = id.replace (/\s/g, "");

            $.ajax({
                type: 'POST',
                url: '/cockpit/org-check-get-user/' + window.organisation_id,
                data: ({
                    id: id,
                }),
                success: function (response) {
                    $('#send-form').removeClass('d-none');
                    $('#connect-pad-modal').data('id', id);
                    $('#connect-pad-modal').data('user_email', response.email);
                    $('#connect-pad-modal').data('user_phone', response.phone);
                    if (response.id) {
                        id = response.id;
                        $("input[name=customer_id]").val(id);
                    }else{
                        $("input[name=customer_id]").val('');
                    }
                    history.pushState(null, null, '/cockpit/' + id);
                    $this.replaceCurrentUser('#connect-pad-modal', response);
                    $('#connect-pad-modal').modal('hide');
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    blockContact() {
        $('body').on('click', '#block-contact', function(e) {
            e.preventDefault();
            let id    = $('.user_data').data('id');
            let phone = $('.user_data').data('user_phone');
            let email = $('.user_data').data('user_email');
            let blocked = $('#block-contact').data('blocked') == "1" ? 0 : 1;

            $.ajax({
                type: 'POST',
                url: '/org-block-contact',
                data: ({
                    id: id,
                    phone: phone,
                    email: email,
                    blocked: blocked,
                }),
                success: function (response) {
                    $('#block-contact').data('blocked', response.blocked);
                    $('#block-contact').toggleClass(['btn-outline-primary', 'btn-primary']);
                    $('#block-contact').text(response.blocked == "1" ? 'Unblock Contact' : 'Block Contact');
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    markAsLead() {
        $('body').on('click', '.mark_as_lead', function(e) {

            e.preventDefault();

            // let id    = $('.user_data').data('id');
            let phone = $('.user_data').data('user_phone');
            let email = $('.user_data').data('user_email');
            // let mark_as_lead = $('.mark_as_lead').data('lead') == "1" ? 0 : 1;

            let timestamp = Math.floor(Date.now() / 1000)
            let randomValue = ('00' + Math.floor((Math.random() * 1000))).slice(-3);
            let uid = timestamp + '' + randomValue

            let sendingData = {
                'uid': uid,
                'phone': phone,
                'email': email,
                'source': 'cockpit'
            }

            $.post('/lead-store', sendingData, function (response) {
                console.log('send lead cockpit: ', sendingData, response);
                if(response.success) {
                    $('.mark_as_lead').data('lead', 1);
                    $('.mark_as_lead').removeClass('btn-outline-primary').addClass('btn-primary');
                } else {
                    $('.mark_as_lead').data('lead', 0);
                    $('.mark_as_lead').removeClass('btn-primary').addClass('btn-outline-primary');
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    messagesSettingsModal() {
        $('body').on('click', '.messages_settings', function(e) {
            $('.form-validation-errors').html('');
            $('.form-validation-errors').removeClass(['alert', 'alert-success']);
            $('#messages_settings_modal').modal('show');
        });
    },
    breakEmailChain() {
        $('body').on('click', '#messages_settings_modal #break_email_chain', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-break-email-chain',
                data: ({
                    email: $('#send-form input[name="email"]').val()
                }),
                success: function (response) {
                    $('.form-validation-errors').addClass(['alert', 'alert-success']);
                    $('.form-validation-errors').html(response.message);
                    setTimeout(function() {
                        $('#messages_settings_modal').modal('hide');
                    }, 2000);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    showForwardButtons() {
        $('body').on('click', '.forwards', function (e) {
            let id = $(this).data('forward');
            $('#forward-' + id).toggleClass(['d-none', 'd-flex']);
        });
    },

    enterDialPadNumber(){
        $('.dialpad-buttons .dialpad_btn').click(function() {
            //$('.dialpad-history').append($(this).data('value'));
            $('.dilpad-code').append($(this).data('value'));
            $('.dialpad_btn').removeClass('clicked');
            $(this).addClass('clicked');
        });

        $('.clear_dialpad_code').click(function(e) {
            e.preventDefault();
            $('.dilpad-code').text('');
            $('.dialpad_btn').removeClass('clicked');
        });

        $('body').on('click', '.show_dialpad', function(e) {
            $("#call_dialpad_modal").modal('show');
        });

        $('body').on('click', '.end-call', function() {
            $('.dialpad-history').text('');
        });
    },
    getEmailAdditionalInfoModal(){
        $('body').on('click', '.message-content .additional-email', (e)=>{
            $.ajax({
                method: 'POST',
                url: '/cockpit/get-email-additioanl-info',
                data: {id: $(e.target).data('id')},
                success: (response)=>{
                    $('#form-container').html(response);
                    $('#email-additional-info-modal').modal('show');
                },
                error: (response)=> {

                }
            });
        });
    },
    showCarbonCopiesModal(){
        $('.show-cc-modal').click((e)=>{
            $('#carbon_copies_modal').modal('show');
        });

        $('.save_carbon_copies_list').click((e)=>{
            let text = $('#cc_email_list').val();
            let list = text.split(/,?\s|,/);
            let validated_list = this.validateEmails(list);
            let json = JSON.stringify(validated_list);
            $('#cc_list').val(json);
            $('.cc-count').text('('+validated_list.length+')');

            $('#carbon_copies_modal').modal('hide');
        });
    },
    clearCCForm(){
        $('.cc-count').text('');
        $('#cc_email_list').val('');
        $('#cc_list').val('');
    },
    validateEmails(emails){
        const re = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);

        let validated_emails = [];
        emails.forEach(email => {
            console.log(re.test(email), email, emails.indexOf(email));
            if (re.test(email) == true) {
                validated_emails.push(email);
            }
        });
        return validated_emails;
    },

    numpadInit(){
        window.addEventListener('keydown', ev=>{
            if(!$('.modal-form-numpad.show').length)
                return
            if($(`#quick-connect-form .numpad-button[data-value="${ev.key}"]`).length)
                $(`#quick-connect-form .numpad-button[data-value="${ev.key}"]`).trigger('click')
            else if(ev.key == 'Backspace')
                $(`#quick-connect-form .backspace-button`).trigger('click')
        })

        $('#quick-connect-form #numpad-input').val(this.numValue)

        $('#quick-connect-form .numpad-button, #quick-connect-form .backspace-button').on('click',ev=>{
            if($(ev.currentTarget).data('value')===null || $(ev.currentTarget).data('value')===undefined)
                return
            let slice = this.numValue[this.numValue.length-1]=='-' ? 2 : 1
            const num = $(ev.currentTarget).data('value');
            let newValue = num==-1
                ? (this.numValue.length>3 ? this.numValue.slice(0,this.numValue.length-slice) : this.numValue)
                : (this.numValue.length+1>15 ? this.numValue : this.numValue+num)
            newValue = newValue.replace(/(\+1)\s*([0-9\*\#]{3})?[\s\-]*([0-9\*\#]{3})?[\s\-]*([0-9\*\#]{4})?/,
                (match,fr,tw,tr,fo)=>`${fr} `+(tw ? tw+'-':'')+(tr ? tr+'-':'')+(fo ?? ''))
            if(newValue != this.numValue){
                this.numValue = newValue
                $('#quick-connect-form #numpad-input').val(this.numValue)
            }
        })

        $('#quick-connect-form #quick-call-numpad-btn').on('click', ev=> {
            if(this.numValue.length<14 || !/^\+1\s+([0-9\*\#]{3})?[\s\-]+([0-9\*\#]{3})?[\s\-]+([0-9\*\#]{4})?/.test(this.numValue)){
                $('#quick-connect-form .text-danger').removeClass('d-none')
                setTimeout(()=>$('#quick-connect-form .text-danger').addClass('d-none'),3000)
                return
            }
            let id = 'phone-' + this.numValue.substring(3);
            console.log('ID:', id)
            id = id.replace (/\s/g, "");
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-check-get-user/' + window.organisation_id,
                data: ({
                    id: id,
                }),
                success: response => {
                    $('#send-form').removeClass('d-none');
                    $('#quick-call-modal').data('id', id);
                    $('#quick-call-modal').data('user_email', response.email);
                    $('#quick-call-modal').data('user_phone', response.phone);
                    if (response.id) {
                        id = response.id;
                        $("input[name=customer_id]").val(id);
                    }else{
                        $("input[name=customer_id]").val('');
                    }
                    history.pushState(null, null, '/cockpit/' + id);
                    this.replaceCurrentUser('#quick-call-modal', response);
                    $('#quick-call-modal').modal('hide');
                    $('.cockpit-buttons #call').trigger('click')
                    setTimeout(()=>{
                        $('#user_call_modal .wait-call').trigger('click')
                    },2000)
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },

}
